import { css } from '@emotion/css';

export const py9 = css`
  padding-top: 0.9rem;
  padding-bottom: 0.9rem;
`;
